setToken = (access_token) => {
  localStorage.setItem('access_token', access_token);
};

getToken = () => {
  return localStorage.getItem('access_token');
};

setLoggedInUser = (loggedInUser) => {
  localStorage.setItem('logged_in_user', JSON.stringify(loggedInUser));
};

getLoggedInUser = () => {
  return JSON.parse(localStorage.getItem('logged_in_user'));
};

setCurrentVehicle = (vehicleId) => {
  localStorage.setItem('current_vehicle', vehicleId);
};

getCurrentVehicle = () => {
  return localStorage.getItem('current_vehicle');
};

clearLocalStorage = () => {
  localStorage.clear();
};

setRole = (role) => {
  localStorage.setItem('role', role);
};

getRole = () => {
  return localStorage.getItem('role');
};

setFleetRole = (fleet, role) => {
  localStorage.setItem(`fleet_${fleet}`, role);
};

getFleetRole = (fleet) => {
  return localStorage.getItem(`fleet_${fleet}`);
};

module.exports = {
  getToken,
  setToken,
  setLoggedInUser,
  getLoggedInUser,
  setCurrentVehicle,
  getCurrentVehicle,
  clearLocalStorage,
  setRole,
  getRole,
  setFleetRole,
  getFleetRole
};
